import React, { useState } from "react";
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { trustedPublications } from "./trusted-publications";

export default class JournalistRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = { journalist: props.journalist };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.journalist !== state.journalist) {
            return {
                journalist: props.journalist
            };
        }
        return null;
    }

    toggleCheckbox(row, property, e) {
        const newJournalist = { ...this.state.journalist, [property]: e.target.checked };
        this.setState({journalist: newJournalist});
        this.props.checkboxHandler(this.state.journalist, 'include', e);
    }

    formatPublication(publication) {
        let publicationName = trustedPublications[publication].name;
        return ( <li key={publication}>{ trustedPublications[publication].favicon ? <img src={trustedPublications[publication].favicon} className="publicationIcon" /> : null } <strong>{publicationName}</strong></li> );
    }
    render() {
        return (
            <TableRow key={this.state.journalist.id}>
                <TableCell><strong>{this.state.journalist.name}</strong></TableCell>
                <TableCell><a href={this.state.journalist.mastodonUrl} target="_blank" rel="noopener noreferrer">{this.state.journalist.mastodon}</a></TableCell>
                <TableCell>{this.state.journalist.twitter}</TableCell>
                <TableCell>
                    <ul className="publications">
                        {this.state.journalist.knownPublications.filter(publication => publication !== '___').map(this.formatPublication)}
                    </ul>
                </TableCell>
                <TableCell>{this.state.journalist.focus}<br/><br/>{this.state.journalist.title}<br/><br/>{this.state.journalist.publication}</TableCell>
                {/*                            <TableCell><Checkbox onChange={e => {
                e.preventDefault();
                toggleCheckbox(row, 'boosts', e);
            }} checked={row.boosts} disabled={!row.include} /></TableCell>*/}
                <TableCell><Checkbox onChange={e => {
                    e.persist();
                    this.toggleCheckbox(this.state.journalist, 'include', e);
                }} checked={this.state.journalist.include} /></TableCell>
            </TableRow>
        );
    }
}
